

import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { getCorporateClients } from "api/thunk/corporateClients/getActions/getCorporateClients";
import { getCorporateClientsByMarathonId } from "api/thunk/corporateClients/getActions/getCorporateClientsByMarathonId";
import { getCorporateClientsByUserId } from "api/thunk/corporateClients/getActions/getCorporateClientsByUserId";
import { getCorporateClientsExcelByMarathonId } from "api/thunk/corporateClients/getActions/getCorporateClientsExcelByMarathonId";
import { getCorporateClientsNamesByMarathonId } from "api/thunk/corporateClients/getActions/getCorporateClientsNamesByMarathonId";
import { getCorporateClientsWithVouchersByMarathonId } from "api/thunk/corporateClients/getActions/getCorporateClientsWithVouchersByMarathonId";
import { getIsUserResponsibleForCorporateClient } from "api/thunk/corporateClients/getActions/getIsUserResponsibleForCorporateClient";
import { getCorporateClientsLookup } from "api/thunk/corporateClients/getActions/getCorporateClientsLookup";

const corporateClientsSlice = createSlice({
  name: "corporateClients",
  initialState,
  reducers: {
    setCorporateClientsLookupId: (state, action) => {
      state.corporateClientsLookupId = action.payload;
    },
    //corporate_clients_lookup
    setCorporateClientsLookupLoading: (state, action) => {
      state.corporateClientsLookup.response.loading = action.payload;
    },
    setCorporateClientsLookup: (state, action) => {
      state.corporateClientsLookup.params.allCorporateClientsLookup = action.payload;
    },
    setCorporateClientsPageSize: (state, action) => {
      state.corporateClientsLookup.params.pageSize = action.payload;
    },
    setCorporateClientsHasMore: (state, action) => {
      state.corporateClientsLookup.params.hasMore = action.payload;
    },
    setCorporateClientsPage: (state, action) => {
      state.corporateClientsLookup.params.page = action.payload;
    },
    setCorporateClientName: (state, action) => {
      state.corporateClientsLookup.params.name = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      //get_corporate_clients
      .addCase(getCorporateClients.pending, (state) => {
        state.corporateClients.response.loading = true;
        state.corporateClients.response.error = null;
      })
      .addCase(getCorporateClients.fulfilled, (state, action) => {
        state.corporateClients.response.loading = false;
        state.corporateClients.response.data = action.payload;
      })
      .addCase(getCorporateClients.rejected, (state, action) => {
        state.corporateClients.response.loading = false;
        state.corporateClients.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
      //corporate_clients_by_marathon_id
      .addCase(getCorporateClientsByMarathonId.pending, (state) => {
        state.corporateClientsByMarathonId.response.loading = true;
        state.corporateClientsByMarathonId.response.error = null;
      })
      .addCase(getCorporateClientsByMarathonId.fulfilled, (state, action) => {
        state.corporateClientsByMarathonId.response.loading = false;
        state.corporateClientsByMarathonId.response.data = action.payload;
      })
      .addCase(getCorporateClientsByMarathonId.rejected, (state, action) => {
        state.corporateClientsByMarathonId.response.loading = false;
        state.corporateClientsByMarathonId.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
      //get-corporate_clients-by_user-id
      .addCase(getCorporateClientsByUserId.pending, (state) => {
        state.corporateClientsByUserId.response.loading = true;
        state.corporateClientsByUserId.response.error = null;
      })
      .addCase(getCorporateClientsByUserId.fulfilled, (state, action) => {
        state.corporateClientsByUserId.response.loading = false;
        state.corporateClientsByUserId.response.data = action.payload;
      })
      .addCase(getCorporateClientsByUserId.rejected, (state, action) => {
        state.corporateClientsByUserId.response.loading = false;
        state.corporateClientsByUserId.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
      //get_corporate_clients_excel_by_marathon-id
      .addCase(getCorporateClientsExcelByMarathonId.pending, (state) => {
        state.corporateClientsExcelByMarathonId.response.loading = true;
        state.corporateClientsExcelByMarathonId.response.error = null;
      })
      .addCase(getCorporateClientsExcelByMarathonId.fulfilled, (state, action) => {
        state.corporateClientsExcelByMarathonId.response.loading = false;
        state.corporateClientsExcelByMarathonId.response.data = action.payload;
      })
      .addCase(getCorporateClientsExcelByMarathonId.rejected, (state, action) => {
        state.corporateClientsExcelByMarathonId.response.loading = false;
        state.corporateClientsExcelByMarathonId.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
      //get_corporate_clients_names_by_marathon-id
      .addCase(getCorporateClientsNamesByMarathonId.pending, (state) => {
        state.corporateClientsNamesByMarathonId.response.loading = true;
        state.corporateClientsNamesByMarathonId.response.error = null;
      })
      .addCase(getCorporateClientsNamesByMarathonId.fulfilled, (state, action) => {
        state.corporateClientsNamesByMarathonId.response.loading = false;
        state.corporateClientsNamesByMarathonId.response.data = action.payload;
      })
      .addCase(getCorporateClientsNamesByMarathonId.rejected, (state, action) => {
        state.corporateClientsNamesByMarathonId.response.loading = false;
        state.corporateClientsNamesByMarathonId.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
      //get_corporate_clients_with_vouchers_by_marathon-id
      .addCase(getCorporateClientsWithVouchersByMarathonId.pending, (state) => {
        state.corporateClientsWithVouchersByMarathonId.response.loading = true;
        state.corporateClientsWithVouchersByMarathonId.response.error = null;
      })
      .addCase(getCorporateClientsWithVouchersByMarathonId.fulfilled, (state, action) => {
        state.corporateClientsWithVouchersByMarathonId.response.loading = false;
        state.corporateClientsWithVouchersByMarathonId.response.data = action.payload;
      })
      .addCase(getCorporateClientsWithVouchersByMarathonId.rejected, (state, action) => {
        state.corporateClientsWithVouchersByMarathonId.response.loading = false;
        state.corporateClientsWithVouchersByMarathonId.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
      //get_is_user_responsible_for_corporate-client
      .addCase(getIsUserResponsibleForCorporateClient.pending, (state) => {
        state.isUserResponsibleForCorporateClient.response.loading = true;
        state.isUserResponsibleForCorporateClient.response.error = null;
      })
      .addCase(getIsUserResponsibleForCorporateClient.fulfilled, (state, action) => {
        state.isUserResponsibleForCorporateClient.response.loading = false;
        state.isUserResponsibleForCorporateClient.response.data = action.payload;
      })
      .addCase(getIsUserResponsibleForCorporateClient.rejected, (state, action) => {
        state.isUserResponsibleForCorporateClient.response.loading = false;
        state.isUserResponsibleForCorporateClient.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })

      //get_corporate_clients_lookup
      .addCase(getCorporateClientsLookup.pending, (state) => {
        state.corporateClientsLookup.response.loading = true;
        state.corporateClientsLookup.response.error = null;
      })
      .addCase(getCorporateClientsLookup.fulfilled, (state, action) => {
        state.corporateClientsLookup.response.loading = false;
        state.corporateClientsLookup.response.data = action.payload;
      })
      .addCase(getCorporateClientsLookup.rejected, (state, action) => {
        state.corporateClientsLookup.response.loading = false;
        state.corporateClientsLookup.response.error =
          typeof action.payload === "string"
            ? action.payload
            : action.error.message || "Неизвестная ошибка";
      })
  }
})

export const {
  setCorporateClientsLookupId,
  setCorporateClientsLookupLoading,
  setCorporateClientsLookup,
  setCorporateClientsPageSize,
  setCorporateClientsHasMore,
  setCorporateClientsPage,
  setCorporateClientName
} = corporateClientsSlice.actions;
export default corporateClientsSlice.reducer;